module.exports = __webpack_public_path__ + "static/media/galeryBaseboards3.b458c50a.jpg";